import React from 'react';
import { Play } from 'lucide-react';
const VIDEO_THUMB = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FTRAINING%20IMAGES%2Fthumb1JohnWick.jpg&site=1856&w=371&h=208&user=1516&opt=w3';
export function VideoSection() {
  return <section className="py-16 md:py-24 bg-brand-gray-900 border-y border-brand-gray-800" data-id="element-187">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-188">
        <p className="text-brand-gray-300 text-lg leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-189">
          See some of our work in the training example break down for
          "Generations Films" as I break down some of the tactics and techniques
          used in the film.
        </p>

        <a href="https://www.youtube.com/watch?v=5J5vQnxJf3w" target="_blank" rel="noreferrer" className="relative inline-block group" data-id="element-190">
          <div className="relative border border-brand-gray-700 overflow-hidden" data-id="element-191">
            <img src={VIDEO_THUMB} alt="Training Breakdown Video" className="block w-full max-w-[500px] h-auto group-hover:opacity-80 transition-opacity" data-id="element-192" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-193">
              <div className="w-16 h-16 bg-brand-teal/90 flex items-center justify-center group-hover:bg-brand-teal transition-colors" data-id="element-194">
                <Play className="w-8 h-8 text-brand-white ml-1" data-id="element-195" />
              </div>
            </div>
          </div>
        </a>
      </div>
    </section>;
}